<template>
  <div class="card comments-activity-card ol-opportunity-actions">
    <CommentsActivityTabs
      v-model="activeTab"
      :hasEvent="hasEvents"
      :fromAdminTasks="fromAdminTasks"
      :permissionFront="permissionFront"
      :isOnlyBilling="isOnlyBilling"
      @emailSelected="handleEmailSelection"
    />

    <div class="ol-opportunity-actions__panels itemsOliver activity">
      <CommentsAction
        v-show="activeTab === 'note'"
        :linkId="linkId"
        @createComment="$emit('createComment', $event)"
      />

      <EmailAction
        v-if="opportunity"
        v-show="activeTab === 'email'"
        :key="emailActionKey"
        :businessContacts="opportunity.business_contacts"
        :linkId="linkId"
        :campaignId="opportunity.link.campaign_id"
        :activateSpark="opportunity.link.activated_spark"
        :emailSelected="opportunity.link.email"
        :labelFromSelected="opportunity.link.label_from"
        @addEmail="$emit('addEmail', $event)"
      />

      <ActivityAction
        v-show="activeTab === 'reminder'"
        :linkId="linkId"
      />

      <CopyEvent
        v-if="hasEvents"
        v-show="activeTab === 'replan'"
        :linkId="linkId"
        :event="meetingEvent"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommentsActivityTabs from "@/components/Opportunities/SingleOpportunity/CommentsActivityTabs.vue";
import CommentsAction from "@/components/Opportunities/SingleOpportunity/CommentsAction.vue";
import EmailAction from "@/components/Opportunities/SingleOpportunity/EmailAction.vue";
import ActivityAction from "@/components/Opportunities/SingleOpportunity/ActivityAction.vue";
import CopyEvent from "@/components/Opportunities/SingleOpportunity/CopyEvent.vue";

export default {
  components: {
    CommentsActivityTabs,
    CommentsAction,
    EmailAction,
    ActivityAction,
    CopyEvent,
  },

  props: {
    fromAdminTasks: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeTab: "note",
      emailActionKey: 0,
    };
  },

  computed: {
    ...mapState({
      opportunity: (state) => state.opportunities.selected.data,
      currentUser: (state) => state.authentication.user,
    }),

    linkId() {
      return this.opportunity && this.opportunity.link
        ? this.opportunity.link.id
        : null;
    },

    hasEvents() {
      return (
        this.opportunity &&
        this.opportunity.events &&
        this.opportunity.events.filter((el) => el.event_id == 3).length > 0
      );
    },

    meetingEvent() {
      if (!this.opportunity || !this.opportunity.events) {
        return null;
      }
      const meetings = this.opportunity.events.filter(
        (el) => el.event_id == 3
      );
      return meetings.length > 0 ? meetings[0] : null;
    },

    permissionFront() {
      return (
        this.currentUser &&
        (this.currentUser.team_role_id == undefined ||
          this.currentUser.team_role_id != 3)
      );
    },

    isOnlyBilling() {
      return (
        this.currentUser &&
        this.currentUser.role_id == 4 &&
        !this.currentUser.sales_representative_id
      );
    },
  },

  methods: {
    handleEmailSelection() {
      this.emailActionKey++;
    },
  },
};
</script>

<style scoped>
.ol-opportunity-actions {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: visible;
}

.ol-opportunity-actions__panels {
  padding: 0;
}
</style>
